import TableHeadCell from './TableHeadCell';
export * from './TableHeadCell';
export default TableHeadCell;
